export enum DeliveryProviders {
  OWN_DELIVERY = 'OWN_DELIVERY',
  ARAMEX = 'ARAMEX',
  BOSTA = 'BOSTA',
  WOLT = 'WOLT',
  EMU = 'EMU',
}

export enum DeliveryMethods {
  COURIER_DELIVERY = 'COURIER_DELIVERY',
  CLICK_AND_COLLECT = 'CLICK_AND_COLLECT',
}

export enum DeliveryMechanic {
  ON_DEMAND = 'ON_DEMAND',
  SCHEDULED = 'SCHEDULED',
  PICKUP = 'PICKUP',
}

export enum MechanicType {
  SLOT = 'SLOT',
  ON_DEMAND = 'ON_DEMAND',
}

export enum ETAPaymentMethod {
  Card = 'CARD',
  Cash = 'CASH',
  PhoneAirtel = 'PHONE_AIRTEL',
  PhoneMoov = 'PHONE_MOOV',
  QR = 'QR',
}

const PHONE_PAYMENT_METHODS: ETAPaymentMethod[] = [
  ETAPaymentMethod.PhoneAirtel,
  ETAPaymentMethod.PhoneMoov,
];

export const isPhonePaymentMethod = (
  method: ETAPaymentMethod,
): method is ETAPaymentMethod.PhoneAirtel | ETAPaymentMethod.PhoneMoov =>
  PHONE_PAYMENT_METHODS.includes(method);
